export enum ERROR_CODES {
  INTERNAL_ERROR = 0,
  INSUFFICIENT_FUNDS = 1,
  INVALID_CARD = 2,
  PURCHASE_ALREADY_CONFIRMED = 3,
  CONFIRMATION_PURCHASE_ID_NOT_FOUND = 4,
  CONFIRMATION_BAD_USER = 30,
  AUTHENTICATION_ERROR = 34,
  AUTHENTICATION_ERROR_3DS = 39,
  PAYMENT_PROVIDER = 40,
  CONFIRMATION_PAYMENT = 45,
  PAYMENT_TIMEOUT = 46,
  PAYMENT_CONNECTION = 47,
  PARTIAL_PAYMENT_NOT_ALLOWED = 48,
  AUTHORISATION_DECLINED = 49,
  CONFIRMATION_PURCHASE_LOCKED = 50,
  CONFIRMATION = 60,
  CONFIRMATION_RULES = 61,
  CONFIRMATION_NOT_PAYABLE = 65,
}
